import React from 'react';
import TodoList from '../Todo-list/Todo-list';
import Panel from '../Panel/Panel';
import AppHeader from '../App-header/App-header';
import ItemAddForm from '../Item-add-form/Item-add-form';
import './App.css';

class App extends React.Component {
  maxId = 10;

  state = {
    todoData: [
      this.createTodo('Drink coffee'),
      this.createTodo('Learn React'),
      this.createTodo('Build React App'),
    ],
    term: '',
    filter: 'all', // all || active || done
  };

  createTodo(label) {
    return {
      label,
      important: false,
      done: false,
      id: this.maxId++,
    };
  }
  deleteTodo = (id) => {
    this.setState((state) => {
      const index = state.todoData.findIndex((el) => el.id === id);

      const res = [
        ...state.todoData.slice(0, index),
        ...state.todoData.slice(index + 1),
      ];

      return {
        todoData: res,
      };
    });
  };

  addTodo = (label) => {
    const newItem = this.createTodo(label);

    this.setState((state) => {
      const newArr = state.todoData;
      newArr.push(newItem);
      return {
        todoData: newArr,
      };
    });
  };

  returnNewState = (arr, id, prop) => {
    const index = arr.findIndex((el) => el.id === id);

    const oldItem = arr[index];
    const newItem = { ...oldItem, [prop]: !oldItem[prop] };

    return [...arr.slice(0, index), newItem, ...arr.slice(index + 1)];
  };

  onToggleImportant = (id) => {
    this.setState((state) => {
      return {
        todoData: this.returnNewState(state.todoData, id, 'important'),
      };
    });
  };
  onToggleDone = (id) => {
    this.setState((state) => {
      return {
        todoData: this.returnNewState(state.todoData, id, 'done'),
      };
    });
  };

  search(items, term) {
    if (term.length === 0) {
      return items;
    }
    return items.filter(
      (item) => item.label.toLowerCase().indexOf(term.toLowerCase()) > -1
    );
  }

  onSearchChange = (term) => {
    this.setState({ term });
  };

  filter(items, filter) {
    switch (filter) {
      case 'all':
        return items;
      case 'active':
        return items.filter((item) => !item.done);
      case 'done':
        return items.filter((item) => item.done);
      default:
        return items;
    }
  }

  onFilterChange = (filter) => this.setState({ filter });

  render() {
    const { todoData, term, filter } = this.state;

    const visibleItems = this.filter(this.search(todoData, term), filter);

    const doneCount = todoData.filter((el) => el.done).length;
    const todoCount = todoData.length - doneCount;

    return (
      <div className="container">
        <div className="Todo-list-parent">
          <AppHeader todo={todoCount} done={doneCount} />
          <Panel
            onSearchChange={this.onSearchChange}
            filter={filter}
            onFilterChange={this.onFilterChange}
          />
          <TodoList
            onToggleImportant={this.onToggleImportant}
            onToggleDone={this.onToggleDone}
            onDeleted={this.deleteTodo}
            todoData={visibleItems}
          />
          <ItemAddForm onAdd={this.addTodo} />
        </div>
      </div>
    );
  }
}

export default App;
